module.exports = __webpack_public_path__ + "static/media/color-butterfly-first-page.0426e107.svg";